import { isEmpty } from 'lodash'
import React from 'react'
import { makeStyles } from 'tss-react/mui'
import { ExtendableStyles } from 'utils-next/types'

import { Chip, Divider, Grid, Theme, Typography } from '@mui/material'

export type SearchEngineCompanyDetailData = {
  crunchbaseId: string
  linkedinId: string
  pitchbookId: string
  apolloId: string
  rank: number
  linkedinUrl: string
  companyUrl: string
  websiteContent: React.ReactNode
  description?: React.ReactNode
  shortDescription?: React.ReactNode
  lastFundingOn?: string
  lastFundingRound: string | null
  parsedLocation?: string
  categories: string[]
}

type SearchEngineCompanyDetailProps = ExtendableStyles & SearchEngineCompanyDetailData

export function SearchEngineCompanyDetail({
  crunchbaseId,
  linkedinId,
  pitchbookId,
  apolloId,
  rank,
  linkedinUrl,
  description,
  shortDescription,
  websiteContent,
  lastFundingOn,
  lastFundingRound,
  parsedLocation,
  categories,
}: SearchEngineCompanyDetailProps) {
  const { classes } = useStyles()

  return (
    <Grid container spacing={3}>
      {shortDescription && (
        <Grid item md={12}>
          <Typography className={classes.shortDescription}>{shortDescription}</Typography>
        </Grid>
      )}
      {linkedinUrl && (
        <Grid item md={3}>
          <Typography variant="h6">Linkedin Url</Typography>
          <Typography noWrap>
            <a target="_blank" href={linkedinUrl} rel="noopener noreferrer">
              linkedin url
            </a>
          </Typography>
        </Grid>
      )}
      <Grid item md={3}>
        <Typography variant="h6">IDs</Typography>
        <Typography>
          <b>CrunchBase:</b> {crunchbaseId || <i>none</i>}
        </Typography>
        <Typography>
          <b>LinkedIn:</b> {linkedinId || <i>none</i>}
        </Typography>
        <Typography>
          <b>Pitchbook:</b> {pitchbookId || <i>none</i>}
        </Typography>
        <Typography>
          <b>Apollo:</b> {apolloId || <i>none</i>}
        </Typography>
      </Grid>
      {lastFundingRound && (
        <Grid item md={3}>
          <Typography variant="h6">Last Funding Event</Typography>
          <Typography noWrap>{lastFundingRound}</Typography>
        </Grid>
      )}
      {lastFundingOn && (
        <Grid item md={3}>
          <Typography variant="h6">Funding On</Typography>
          <Typography noWrap>{lastFundingOn}</Typography>
        </Grid>
      )}
      {parsedLocation && (
        <Grid item md={3}>
          <Typography variant="h6">Location</Typography>
          <Typography noWrap>{parsedLocation}</Typography>
        </Grid>
      )}
      <Grid item md={3}>
        <Typography variant="h6">Rank</Typography>
        <Typography noWrap>{rank}</Typography>
      </Grid>
      {!isEmpty(categories) && (
        <Grid item>
          <Typography variant="h6">Categories</Typography>
          {categories.map((category) => (
            <Chip className={classes.chip} size="small" label={category} key={category} />
          ))}
        </Grid>
      )}
      {description && (
        <Grid item md={12}>
          <Divider />
          <Typography className={classes.longSectionTitle} variant="h6">
            Description
          </Typography>
          <Typography>{description}</Typography>
        </Grid>
      )}
      {websiteContent && (
        <Grid item md={12}>
          <Divider />
          <Typography className={classes.longSectionTitle} variant="h6">
            Website Content
          </Typography>
          <Typography>{websiteContent}</Typography>
        </Grid>
      )}
    </Grid>
  )
}

const useStyles = makeStyles()(({ spacing }: Theme) => ({
  chip: {
    marginTop: spacing(0.5),
    marginBottom: spacing(0.5),
    marginRight: spacing(1),
  },
  shortDescription: {
    marginBottom: spacing(2),
  },
  longSectionTitle: {
    marginTop: spacing(2),
    marginBottom: spacing(2),
  },
}))
